<template>
    <div class="layer-content common" style="padding:0;max-height: 800px">
		<section id="step">
			<div class="grid--step">
				<div class="pt-step">
					<ul>
						<li :class="[step>=1?'current':'',step>1?'step01':'']"><span>01.신청정보 확인</span></li><!--
                        --><li :class="[step>=2?'current':'',step>2?'step02':'']"><span>02.원정보 확인</span></li><!--
                        --><li :class="[step>=3?'current':'',step>3?'step03':'']"><span>03.결제정보등록</span></li><!--
                        --><li :class="[step>=4?'current':'',step==4?'step04':'']"><span>04.서비스신청완료</span></li>
                    </ul>
				</div>
			</div>
		</section>
        <div id="content" class="sub" style="padding: 20px 20px 10px 20px">
            <div class="grid--con-sub" style="margin:0;width:calc( 100% - 40px ) !important;">
                <template v-if="step == 1">
                    <div class="info2" style="padding-bottom:10px;">서비스 신청을 위해 <span class="pc02">신청정보를 확인</span>을 해주세요.</div>
                    <div class="balance-sort-wrap __grid--2">
                        <div class="balance-sort-con">
                            <div class="box-type04">
                                <div class="entry-cho">
                                    <div class="f-left pdt5">
                                        <label for="chk_001" style="cursor: pointer">
                                            <span class="box"></span>
                                            <span class="label-txt">보조금</span>
                                        </label>
                                    </div>
                                    <div class="f-right">
                                        <button class="small _bt-white" @click="openOrderSeInfoPopup()"><span>자세히보기</span></button>
                                    </div>
                                </div>
                                <table class="tb-none">
                                    <colgroup>
                                        <col style="width:33%" />
                                        <col style="width:*" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>안심등하원 신청 수량</th>
                                            <td>
                                                <span>
                                                    리더기 수량 :
                                                    <input type="text"
                                                            class="mgl5"
                                                            style="width:40px; height:25px;line-height: 16px;"
                                                            maxlength="3"
                                                            @keydown="$onbiLib.onlyNumberKeydown()" v-model="step1.orderInfo.detectorCnt"
                                                            @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;대,&nbsp;&nbsp;
                                                    태그 수량 : 
                                                    <input type="text"
                                                            class="mgl5"
                                                            style="width:40px; height:25px;line-height: 16px;"
                                                            maxlength="3"
                                                            @keydown="$onbiLib.onlyNumberKeydown()" v-model="step1.orderInfo.tagCnt"
                                                            @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;개
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>납부금액</th>
                                            <td>{{$onbiLib.addComma(orderAmt)}}원</td>
                                        </tr>
                                        <tr v-if="step1.orderInfo.detectorCnt == 0 && step1.orderInfo.tagCnt == 0">
                                            <td colspan="2">
                                                <span class="txt-type4">
                                                    리더기 수량 또는 태그 수량을 먼저 입력해주세요.
                                                </span>
                                                <br/>
                                                <span class="txt-type4">
                                                    보조금은 리더기 , 태그 수량을 필수로 입력해주셔야 합니다.
                                                </span>
                                            </td>
                                        </tr>
                                        <template v-if="step1.orderInfo.detectorCnt > 0|| step1.orderInfo.tagCnt > 0">
                                            <tr>
                                                <th>결제요청일</th>
                                                <td>
                                                    <vue-datepicker ref="subsidyDatePicker"
                                                    :type="'day'"
                                                    :sel-callback-func="selSubsidyPayDtCallbackFunc"
                                                    :set-date="step1.orderInfo.payDueDt"
                                                    :set-btn-class="'_bt-ic11'"
                                                    ></vue-datepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>납부방법</th>
                                                <td>
                                                    <input type="radio"
                                                        id="paymthdCdrdi01"
                                                        name="paymthdCdrdi01"
                                                        v-model="step1.orderInfo.paymthdCd"
                                                        value="P02"/>
                                                    <label for="paymthdCdrdi01">
                                                        <span class="box"></span>
                                                        <span class="label-txt">&nbsp;신용(체크)카드</span>
                                                    </label>
                                                    <input type="radio"
                                                        id="paymthdCdrdi02"
                                                        name="paymthdCdrdi02"
                                                        v-model="step1.orderInfo.paymthdCd"
                                                        value="P04"/>
                                                    <label for="paymthdCdrdi02">
                                                        <span class="box"></span>
                                                        <span class="label-txt">&nbsp;무통장 입금</span>
                                                    </label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>납부정보</th>
                                                <td>
                                                    <ul v-if="step1.orderInfo.paymthdCd == 'P04'">
                                                        <li class="mgb5">견적서상의 계좌번호로 입금바랍니다.</li>
                                                        <li class="txt-type4">
                                                            입금자명은 '사업자등록번호'로 입금해주시기 바랍니다.<br/>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;('-'제외)
                                                        </li>
                                                    </ul>
                                                    <template v-if="step1.orderInfo.paymthdCd == 'P02'">
                                                        <span class="txt-type4">납부할 카드는 마이페이지에서 등록해주세요.</span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="balance-sort-con">
                            <div class="box-type04">
                                <div class="entry-cho">
                                    <div class="f-left pdt5">
                                        <label for="chk_002" style="cursor: pointer">
                                            <span class="box"></span>
                                            <span class="label-txt">자부담금</span>
                                        </label>
                                    </div>
                                    <div class="f-right">
                                        <button class="small _bt-white" @click="openOrderSeInfoPopup()"><span>자세히보기</span></button>
                                    </div>
                                </div>
                                <table class="tb-none">
                                    <colgroup>
                                        <col style="width:33%" />
                                        <col style="width:*" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>안심등하원 신청 수량</th>
                                            <td>
                                                <span>
                                                    리더기 수량 :
                                                    <input type="text"
                                                            class="mgl5"
                                                            style="width:40px; height:25px;line-height: 16px;"
                                                            maxlength="3"
                                                            @keydown="$onbiLib.onlyNumberKeydown()" v-model="step1.selfOrderInfo.detectorCnt"
                                                            @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;대,&nbsp;&nbsp;
                                                    태그 수량 : 
                                                    <input type="text"
                                                            class="mgl5"
                                                            style="width:40px; height:25px;line-height: 16px;"
                                                            maxlength="3"
                                                            @keydown="$onbiLib.onlyNumberKeydown()" v-model="step1.selfOrderInfo.tagCnt"
                                                            @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;개
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>납부금액</th>
                                            <td>{{$onbiLib.addComma(selfAmt)}}원</td>
                                        </tr>
                                        <tr v-if="step1.selfOrderInfo.detectorCnt == 0 && step1.selfOrderInfo.tagCnt == 0">
                                            <td colspan="2">
                                                <span class="txt-type4">
                                                    리더기 수량 또는 태그 수량을 먼저 입력해주세요.
                                                </span>
                                                <br/>
                                                <span class="txt-type4">
                                                    자부담금으로 결제가 필요없으신 경우 리더기, 태그 수량을 0으로 입력하시면됩니다.
                                                </span>
                                            </td>
                                        </tr>
                                        <template v-if="step1.selfOrderInfo.detectorCnt > 0 || step1.selfOrderInfo.tagCnt > 0">
                                            <tr>
                                                <th>결제요청일</th>
                                                <td>
                                                    <vue-datepicker ref="subsidyDatePicker"
                                                    :type="'day'"
                                                    :sel-callback-func="selSelfPayDtCallbackFunc"
                                                    :set-date="step1.selfOrderInfo.payDueDt"
                                                    :set-btn-class="'_bt-ic11'"
                                                    ></vue-datepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>납부방법</th>
                                                <td>
                                                    <input type="radio"
                                                        id="paymthdCdrdi03"
                                                        name="paymthdCdrdi03"
                                                        v-model="step1.selfOrderInfo.paymthdCd"
                                                        value="P02"/>
                                                    <label for="paymthdCdrdi03">
                                                        <span class="box"></span>
                                                        <span class="label-txt">&nbsp;신용(체크)카드</span>
                                                    </label>
                                                    <input type="radio"
                                                        id="paymthdCdrdi04"
                                                        name="paymthdCdrdi04"
                                                        v-model="step1.selfOrderInfo.paymthdCd"
                                                        value="P04"/>
                                                    <label for="paymthdCdrdi04">
                                                        <span class="box"></span>
                                                        <span class="label-txt">&nbsp;무통장 입금</span>
                                                    </label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>납부정보</th>
                                                <td>
                                                    <ul v-if="step1.selfOrderInfo.paymthdCd == 'P04'">
                                                        <li class="mgb5">견적서상의 계좌번호로 입금바랍니다.</li>
                                                        <li class="txt-type4">
                                                            입금자명은 '사업자등록번호'로 입금해주시기 바랍니다.<br/>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;('-'제외)
                                                        </li>
                                                    </ul>
                                                    <template v-if="step1.selfOrderInfo.paymthdCd == 'P02'">
                                                        <span class="txt-type4">납부할 카드는 마이페이지에서 등록해주세요.</span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="btn-wrap t-line center mgt20">
                        <button class="big _bt-navy" @click="saveSrveInfo()"><span>확인</span></button>
                    </div>
                </template>

                <template v-if="step == 2">
                    <div class="info2">서비스 신청을 위해 <span class="pc02">원 정보 확인</span>을 해주세요.</div>
                    <table class="tb-row mgt10">
                        <colgroup>
                            <col style="width:20%">
                            <col style="width:30%">
                            <col style="width:20%">
                            <col style="width:30%">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>시/도</th>
                                <td>{{step2.fcltInfo.sidoNm}}</td>
                                <th>원장명</th>
                                <td>{{step2.fcltInfo.rprsntvNm}}</td>
                            </tr>
                            <tr>
                                <th>시/군/구</th>
                                <td>{{step2.fcltInfo.sigunguNm}}</td>
                                <th>설립유형</th>
                                <td>{{step2.fcltInfo.fcltyTyNm}}</td>
                            </tr>
                            <tr>
                                <th>원명</th>
                                <td>{{step2.fcltInfo.fcltNm}}</td>
                                <th>전화번호</th>
                                <td>{{step2.fcltInfo.tlphon}}</td>
                            </tr>
                            <tr>
                                <th>고유번호(사업자등록번호)</th>
                                <td>{{step2.fcltInfo.bizrno}}</td>
                                <th>아동 수(정원)</th>
                                <td>{{step2.fcltInfo.psncpa}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="btn-wrap t-line center mgt40">
                        <button class="big _bt-white" @click="btn_beforeClick()"><span>이전</span></button>
                        <button class="big _bt-navy" @click="btn_nextClick()"><span>확인 완료</span></button>
                    </div>
                </template>

                <template v-if="step == 3">
                    <div class="sv-req-payment" style="padding: 0px;">
                        <!-- <div class="entry-title">{{ step2.fcltInfo.fcltNm }} 신청 서비스 금액</div> -->
                        <table class="tb-row mgt20">
                            <colgroup>
                                <col style="width: 16%;">
                                <col style="width: 21%;">
                                <col style="width: 21%;">
                                <col style="width: 21%;">
                                <col style="width: 21%;">
                            </colgroup>
                            <thead>
                            <tr>
                                <th>현원</th>
                                <td v-for="(goodsInfo,index) in step3.srvcGoodsList"  style="padding:10px !important;"
                                    :key="'goodsInfo' + index" class="__center last">{{goodsInfo.goodsDc}}</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th>가격(VAT 포함)</th>
                                <td class="last __center" v-for="(goodsInfo,index) in step3.srvcGoodsList"  style="padding:10px !important;"
                                    :key="'goodsInfo' + index">{{$onbiLib.addComma(goodsInfo.goodsMtAmount)}}원</td>
                            </tr>
                            </tbody>
                        </table>
                        <span class="pc01 mgt10" style="display:block; float:right;font-size:14px;">※ 월 이용료는 결제처리 직전 아동 현원 기준 가격으로 결제 됩니다.( 결제일은 매월 20일 입니다. / LG U+ LTE 통신비 포함)</span>
                    </div>
                    <!--
                    <table class="tb-row mgt20" style="padding-top:30px;">
                        <colgroup>
                            <col style="width:16%;">
                            <col style="width:*;">
                        </colgroup>
                        <tbody>
                        <tr>
                            <th style="padding: 5px 15px !important;">결제 방법</th>
                            <td style="padding: 5px 15px !important;">
                                <div class="form-all">
                                    <input type="radio"
                                        id="rdi01"
                                        name="payMeans"
                                        v-model="step3.selPayMeansCd"
                                        :value="'P02'">
                                    <label for="rdi01">
                                        <span class="box"></span>
                                        <span class="label-txt">신용(체크)카드</span>
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th style="padding: 5px 15px !important;">영수증 발행</th>
                            <td style="padding: 5px 15px !important;">
                                <ul class="txt-type1 depth2">
                                    <li>부가가치세법 제 33조 2항 및 제 46조 3항에 의거 카드매출전표 등을 발급한 경우에는 세금계산서를 발급해 드리지 않습니다.</li>
                                    <li>신용(체크)카드 결제의 경우 발급받으신 카드매출전표 등을 통하여 매입세액 공제를 받으실 수 있습니다.</li>
                                    <li>영수증 발행은 마이페이지에서 가능합니다.</li>
                                </ul>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    -->
                    <div class="sv-req-terms-bottom" style="padding: 10px 30px;margin-top:50px;">
                        <table class="tb-none">
                            <colgroup>
                                <col style="width:*;">
                                <col style="width:15%;">
                            </colgroup>
                            <tbody>
                            <tr>
                                <td style="height:25px">
                                    <div class="form-all">
                                        <input type="checkbox" id="chk1" value="SBIW02" v-model="step3.chkAgrees">
                                        <label for="chk1" style="cursor: pointer">
                                            <span class="box"></span>
                                            <span class="label-txt">아이오감 서비스 이용약관에 동의합니다.</span>
                                        </label>
                                    </div>
                                </td>
                                <td class="__right"><button class="middle _bt-white" @click="openTosAgreePopup()"><span>자세히보기</span></button></td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="form-all">
                                        <input type="checkbox" id="chk_all" value="ALL" v-model="step3.chkAgrees">
                                        <label for="chk_all" style="cursor: pointer">
                                            <span class="box"></span>
                                            <span class="label-txt">결제할 서비스 내용을 확인하였으며, 구매에 동의합니다. (전자상거래법 제 8조 2항 근거)</span>
                                        </label>
                                    </div>
                                </td>
                                <td class="__right"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="btn-wrap center mgt40">
                        <button class="big _bt-white" @click="btn_beforeClick()"><span>이전</span></button>
                        <button class="big _bt-navy" @click="btn_srvcCompClick()"><span>서비스 신청 완료</span></button>
                    </div>
                </template>

                <template v-if="step == 4">
                    <div class="sv-req-comp mgt50" style="margin-bottom:50px;">
                        <div class="img-com __icon06">
                            <span>완료 아이콘</span>
                        </div>
                        <div class="entry-title">감사합니다. 서비스 신청이 완료되었습니다.</div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    const mixinStep1 = {
        data: function () {
            return {
                step1: {
                    srvcInfo : new Array(),
                    orderInfo : {},
                    selfOrderInfo : {},
                    addOrderInfo : null,
                    defOrderInfo : {
                       reqstSn : '',
                        orderSe : '001',
                        tagSe : 'NFC',
                        detectorCnt : '1',
                        tagCnt : '0',
                        payDueDt : null,
                        paymthdCd : 'P04',
                        bankCd : '',
                        accountNo : '',
                        srvcAmt : '300000',
                    },
                    defSelfOrderInfo : {
                        reqstSn : '',
                        orderSe : '002',
                        tagSe : 'NFC',
                        detectorCnt : '0',
                        tagCnt : '0',
                        payDueDt : null,
                        paymthdCd : 'P04',
                        bankCd : '',
                        accountNo : '',
                    },
                    bankList : [
                        {agencyNo : 'AG0000000000', agencyNm : '온앤온정보시스템', bankCd : '011', bankNm : '농협', accountNm : '(주)온앤온정보시스템', accountNo : '089-01-313643'}, 
                        {agencyNo : 'AG0000000000', agencyNm : '온앤온정보시스템', bankCd : '004', bankNm : '국민', accountNm : '(주)온앤온정보시스템', accountNo : '828-2010-4068-953'}, 
                        {agencyNo : 'AG0000000000', agencyNm : '온앤온정보시스템', bankCd : '088', bankNm : '신한', accountNm : '(주)온앤온정보시스템', accountNo : '140-00748-8045'}, 
                        {agencyNo : 'AG0000000000', agencyNm : '온앤온정보시스템', bankCd : '020', bankNm : '우리', accountNm : '(주)온앤온정보시스템', accountNo : '1005-280-121211'}, 
                        {agencyNo : 'AG1905002500', agencyNm : 'e편한시스템', bankCd : '003', bankNm : '기업', accountNm : '(주)온앤온정보시스템', accountNo : '088-105672-01-087'}, 
                        {agencyNo : 'AG1905002100', agencyNm : 'e보육꼬마집', bankCd : '003', bankNm : '기업', accountNm : '(주)온앤온정보시스템', accountNo : '088-105672-01-070'}, 
                        {agencyNo : 'AG1905002200', agencyNm : '보육나라', bankCd : '003', bankNm : '기업', accountNm : '(주)온앤온정보시스템', accountNo : '088-105672-04-126'}, 
                        {agencyNo : 'AG1905002300', agencyNm : '秀전자장부', bankCd : '003', bankNm : '기업', accountNm : '(주)온앤온정보시스템', accountNo : '088-105672-04-133'}, 
                        {agencyNo : 'AG1905002400', agencyNm : '에스크로기획', bankCd : '088', bankNm : '신한', accountNm : '(주)온앤온정보시스템', accountNo : '140-009-699016'}, 
                        {agencyNo : 'AG1905002600', agencyNm : '장부나라', bankCd : '088', bankNm : '신한', accountNm : '(주)온앤온정보시스템', accountNo : '100-029-193681'}, 
                        {agencyNo : 'AG1407021702', agencyNm : '그물정보시스템', bankCd : '020', bankNm : '우리', accountNm : '(주)온앤온정보시스템', accountNo : '100-032-884429'}, 
                        {agencyNo : 'AG1909170902', agencyNm : '이두희', bankCd : '088', bankNm : '신한', accountNm : '(주)온앤온정보시스템', accountNo : '100-032-884429'}, 
                        {agencyNo : 'AG1407021703', agencyNm : '인텍유나이티드', bankCd : '081', bankNm : '하나', accountNm : '(주)온앤온정보시스템', accountNo : '298-910040-73204'}, 
                    ],
                    agencyBankList : new Array(),
                    agencyNo : '',
                    tagCfmAt : 'N',
                }
            }
        },
        methods : {
            selSubsidyPayDtCallbackFunc : function(date){
                this.step1.orderInfo.payDueDt = date;
            },
            selSelfPayDtCallbackFunc : function(date){
                this.step1.selfOrderInfo.payDueDt = date;
            },
        },
        computed : {
            orderAmt : function(){
                const orderInfo = this.step1.orderInfo;
                let detectorAmt = 0;
                if(orderInfo.detectorCnt > 1){
                    detectorAmt = 300000*1 + 220000 * Number(orderInfo.detectorCnt-1);
                }else{
                     detectorAmt = 300000 * Number(orderInfo.detectorCnt);
                }

                let tagAmt = Number(orderInfo.tagCnt) * 5000;
                return detectorAmt + tagAmt;
            },
            selfAmt : function(){
                const orderInfo = this.step1.orderInfo;
                const selfOrderInfo = this.step1.selfOrderInfo;
                let detectorAmt = 0;

                if(this.step1.selfOrderInfo.detectorCnt > 0){
                    if(Number(orderInfo.detectorCnt) > 0 ){
                        detectorAmt = 220000 * selfOrderInfo.detectorCnt;
                    }else{
                        detectorAmt = 300000*1 + 220000 * Number(selfOrderInfo.detectorCnt-1);
                    }
                }

                let tagAmt = Number(selfOrderInfo.tagCnt) * 5000;
                return detectorAmt + tagAmt;
            }
        }
    }

    const mixinStep2 = {
        data: function () {
            return {
                step2: {
                    fcltInfo: new Array()
                }
            }
        },
    }

    const mixinStep3 = {
        data: function () {
            return {
                step3: {
                    srvcGoodsList: new Array(),
                    selPayTypeCd:'PT1',
                    payTypeList: [
                        {payTypeCd:'PT1',payTypeNm:'월 정기 결제'},
                        {payTypeCd:'PT4',payTypeNm:'연 정기 결제'}
                    ],
                    selPayMeansCd:'P02',
                    chkAgrees:[],
                }
            }
        },
        methods : {
            btn_srvcCompClick : function(){
                const _this = this;
                if(this.chkValid()){ return false; }

                const srvcGoodsList = _this.getFcltGoodsList();

                this.axios.post('/i5gam/srvc/updateMberGoods.act',{
                    srvcGoodsList:_this.getFcltGoodsList(),
                    goodsCd : srvcGoodsList[0].goodsCd,
                    mberNo : _this.mberInfo.mberNo,
                    fcltcd : _this.param.fcltcd,
                    reqstSn : _this.param.reqstSn,
                    agencyNo : _this.step1.agencyNo,
                }).then(function(response) {
                    const procInfo = response.data.procInfo;
                    if(procInfo.procCode == '000'){
                        if(this.step1.tagCfmAt == 'Y'){
                            this.updateI5gamSrvcExl();  //태그수량 확정인 경우 I5GAM_SRVC_EXL에 REQST_SN 맵팡   
                        }else{
                            this.step = 4;
                        }
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            chkValid: function(){
                let clearSrvcAgreeAt = true;

                const _this = this;
                if(_this.step3.chkAgrees.length < 2){
                    _this.$toasted.show('서비스 이용약관에 동의하셔야 합니다.');
                    clearSrvcAgreeAt = false;
                }

                if(!clearSrvcAgreeAt) return true;
            },
             searchMberGoodsInfo : function(){
                const _this = this;

                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/srvc/searchMberGoodsInfo.act',{
                        srvcGoodsList: _this.getFcltGoodsList(),    
                        reqstSn : _this.param.reqstSn
                    }).then(function(response) {
                        var procInfo = response.data.procInfo;
                        resolve(procInfo);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                });
            },
            getFcltGoodsList: function(){
                const fcltInfo = this.step2.fcltInfo;

                let setGoodsCd = 'GBIW05';
                if(Number(fcltInfo.psncpa) >= 21 && Number(fcltInfo.psncpa) <= 40){
                    setGoodsCd = 'GBIW06';
                }else if(Number(fcltInfo.psncpa) >= 41 && Number(fcltInfo.psncpa) <= 80){
                    setGoodsCd = 'GBIW07';
                }else if(Number(fcltInfo.psncpa) >= 81){
                    setGoodsCd = 'GBIW08';
                }
                 return this.step3.srvcGoodsList.filter(function(info){
                    return info.goodsCd == setGoodsCd;
                })
            },
            openTosAgreePopup: function(){
                const popupInfo = {
                    se:'modal',
                    id:'tosAgreePopup',
                    wid:'700',
                    hei:'',
                    tit:'이용약관 동의',
                    draggableAt:true,
                    param:null
                };

                this.$store.commit('openPopup',popupInfo);
            }
            /*
            btn_regPayCardClick: function(){
                const _this = this;
                if(this.chkValid()){ return false; }

                this.searchBillCardList().then(function(billCardList){
                    if(billCardList.length > 0){
                        const param = {
                            billCardSn : '',
                            billCardList : billCardList,
                            mberGoodsAt : 'Y',
                            regNewBillCardFunc:_this.regNewBillCard,
                            regBillCardFunc:_this.regBillCard
                        }

                        const popupInfo = {
                            se:'modal',
                            id:'billCardListPopup',
                            wid:'860',
                            hei:'',
                            tit:'결제 카드 등록',
                            draggableAt:false,
                            param:param
                        };

                        _this.$store.commit('openPopup',popupInfo);
                    }else{
                        _this.regNewBillCard();
                    }
                }).catch(function (e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            searchBillCardList : function(){
                const _this = this;
                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/srvc/searchBillCardList.act',{
                        mberNo : _this.mberInfo.mberNo
                    }).then(function(response) {
                        resolve(response.data.billCardList);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });

                });
            },
            regNewBillCard: function(){
                const _this = this;

                this.searchMberGoodsInfo().then(function(procInfo){
                    if(typeof(procInfo) != "undefined"&&procInfo != null){
                        var procCode = procInfo.procCode;
                        if(procCode == '000'){
                            const srvcGoodsInfo = procInfo.srvcGoodsInfo;

                            const param = {
                                procSe: 'srvcReq',
                                mberGoodsAt : 'Y',
                                reqstSn: srvcGoodsInfo.reqstSn,
                                goodsCd: srvcGoodsInfo.goodsCd,
                                goodsNm: srvcGoodsInfo.goodsNm,
                                goodsMtAmount: srvcGoodsInfo.goodsMtAmount,
                                goodsYearAmount: srvcGoodsInfo.goodsYearAmount,
                                payTypeCd: _this.step3.selPayTypeCd,
                                paymthdCd: srvcGoodsInfo.paymthdCd,
                                fcltcd: srvcGoodsInfo.fcltcd,
                                mberNo: srvcGoodsInfo.mberNo,
                                mberNm: _this.mberInfo.mberNm,
                                cttpc: _this.mberInfo.cttpc,
                                email: _this.mberInfo.email,
                                reqDefrayDe: srvcGoodsInfo.reqDefrayDe,
                                rm: srvcGoodsInfo.rm,
                                callBackFunc:_this.srvcReqFinish
                            };
                            const popupInfo = {
                                se:'modalBlank',
                                id:'iniPayReqBillPopup',
                                wid:'820',
                                hei:'600',
                                tit:'이니시스결제',
                                draggableAt:false,
                                param:param
                            };

                            _this.$store.commit('openPopup',popupInfo);
                        }
                    }
                }).catch(function (e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            regBillCard: function(billCardInfo,popupIndex){
                var _this = this;

                this.searchMberGoodsInfo().then(function(procInfo){
                    const procCode = procInfo.procCode;
                    if(procCode == '000'){
                        const srvcGoodsInfo = procInfo.srvcGoodsInfo;
                        let totPrice = srvcGoodsInfo.goodsYearAmount;

                        if(srvcGoodsInfo.payTypeCd == 'PT1'){
                            totPrice= srvcGoodsInfo.goodsMtAmount;
                        }

                        _this.axios.post('/i5gam/srvc/srvcReqProc.act',{
                            payTypeCd :_this.step3.selPayTypeCd,
                            mberGoodsAt : 'Y',
                            paymthdCd :srvcGoodsInfo.paymthdCd,
                            totPrice  :totPrice,
                            reqstSn   :srvcGoodsInfo.reqstSn,
                            mberNo    :srvcGoodsInfo.mberNo,
                            fcltcd    :srvcGoodsInfo.fcltcd,
                            goodsCd   :srvcGoodsInfo.goodsCd,
                            billCardSn:billCardInfo.billCardSn
                        }).then(function(response) {
                            const srvcReqProcInfo = response.data.procInfo;

                            if(typeof srvcReqProcInfo != 'undefined'&&srvcReqProcInfo != null){
                                if(srvcReqProcInfo.procCode == '000'){
                                    _this.srvcReqFinish(popupIndex);
                                }else{
                                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                                }
                                }else{
                                _this.$toasted.show(_this.$onbiLib.msg.err.system);
                                }
                        }.bind(this)).catch(function(e) {
                            console.log(e);
                            _this.$toasted.show(_this.$onbiLib.msg.err.system);
                        });
                    }
                });
            },
            srvcReqFinish:function(popupIndex){
                const _this = this;

                _this.axios.post('/i5gam/srvc/chkBo6inUseAt.act',{  //보육인 사용하는 원인지 체크
                    fcltcd : this.param.fcltcd,
                }).then(function(response) {
                    const procInfo = response.data.procInfo;
                    if(procInfo.procCode == '000'){
                        this.$store.commit('closePopup',popupIndex);
                        if(this.step1.tagCfmAt == 'Y'){
                            this.updateI5gamSrvcExl();  //태그수량 확정인 경우 I5GAM_SRVC_EXL에 REQST_SN 맵팡
                        }else{
                            this.step = 4;
                        }
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            updateI5gamSrvcExl : function(){
                const _this = this;
                _this.axios.post('/i5gam/srvc/updateI5gamSrvcExl.act',{ 
                    reqstSn : this.param.reqstSn,
                    exlNo : this.step1.orderInfo.exlNo,
                    no : this.step1.orderInfo.no,
                }).then(function(response) {
                    const procInfo = response.data.procInfo;
                    if(procInfo.procCode == '000'){
                        this.step = 4;
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            */
        }
    }

    export default {
        name: 'srvcTmpReq_popup',
        props : ['param'],
        mixins: [mixinStep1, mixinStep2, mixinStep3],
        data: function(){
            return {
                step : 1,
            }
        },
        methods : {
            btn_nextClick : function(){
                this.step = this.step+1;
            },
            btn_beforeClick : function(){
                this.step = this.step-1;
            },
            saveSrveInfo : function(){
                const _this = this;

                if(this.step1.orderInfo.detectorCnt == 0 && this.step1.orderInfo.tagCnt == 0){
                    this.$toasted.show('보조금의 리더기 또는 태그 수량은 필수 입력 사항입니다.');
                    return true;
                }

                if(this.step1.orderInfo.paymthdCd == ''){
                    _this.$toasted.show('보조금의 납부방법을 선택해주세요.');
                    return false;
                }

                if(this.step1.selfOrderInfo.detectorCnt > 0 || this.step1.selfOrderInfo.tagCnt > 0 ){
                    if(this.step1.selfOrderInfo.paymthdCd == ''){
                        _this.$toasted.show('자부담금의 납부방법을 선택해주세요.');
                    return false;
                }
                }
                

                this.axios.post('/i5gam/srvc/modifyTagOrder.act',{
                    orderInfo : this.step1.orderInfo,
                    selfOrderInfo : this.step1.selfOrderInfo,
                    addOrderInfo : this.step1.addOrderInfo,
                }).then(function() {
                    this.btn_nextClick();
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                }); 
            },
            searchSrvcTmpReqInfo : function(){
                const _this = this;
                this.axios.post('/i5gam/srvc/searchSrvcTmpReqInfo.act',{
                    fcltcd : this.param.fcltcd,
                    reqstSn : this.param.reqstSn,
                    stcode : this.param.stcode,
                    srvcCd : 'SBIW02'
                }).then(function(response) {
                    const srvcInfo = response.data.srvcTmpReqInfo.srvcInfo;
                    const srvcTmpReqInfo = response.data.srvcTmpReqInfo;

                    if(srvcTmpReqInfo.orderYn == 'Y'){
                        _this.step1.orderInfo = srvcTmpReqInfo.orderInfo;
                        _this.step1.orderInfo.reqstSn = _this.param.reqstSn;
                        _this.step1.agencyNo = srvcTmpReqInfo.orderInfo.agencyNo;
                        _this.step1.tagCfmAt = srvcTmpReqInfo.orderInfo.tagCfm == '100' ? 'Y' : 'N';
                    }else{
                        _this.step1.orderInfo = JSON.parse(JSON.stringify(_this.step1.defOrderInfo));
                    }

                    if(srvcTmpReqInfo.selfOrderYn == 'Y'){
                        _this.step1.selfOrderInfo = srvcTmpReqInfo.selfOrderInfo;
                        _this.step1.selfOrderInfo.reqstSn = _this.param.reqstSn;
                        _this.step1.agencyNo = srvcTmpReqInfo.selfOrderInfo.agencyNo;
                        _this.step1.tagCfmAt = srvcTmpReqInfo.selfOrderInfo.tagCfm == '100' ? 'Y' : 'N';
                    }else{
                        _this.step1.selfOrderInfo = JSON.parse(JSON.stringify(_this.step1.defSelfOrderInfo));
                    }

                    if(srvcTmpReqInfo.addOrderYn == 'Y'){
                        _this.step1.addOrderInfo = srvcTmpReqInfo.addOrderInfo;
                        _this.step1.addOrderInfo.reqstSn = _this.param.reqstSn;
                        _this.step1.agencyNo = srvcTmpReqInfo.addOrderInfo.agencyNo;
                        _this.step1.tagCfmAt = srvcTmpReqInfo.addOrderInfo.tagCfm == '100' ? 'Y' : 'N';
                    }

                    _this.step1.srvcInfo = srvcInfo;
                    _this.step2.fcltInfo = response.data.srvcTmpReqInfo.fcltInfo;
                    _this.step3.srvcGoodsList = response.data.srvcTmpReqInfo.srvcGoodsList;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            openOrderSeInfoPopup : function(){
                const popupInfo = {
                    se:'modal',
                    id:'orderSeInfoPopup',
                    wid:'670',
                    hei:'',
                    tit:'정산 구분 안내',
                    draggableAt:false,
                };

                this.$store.commit('openPopup',popupInfo);
            }
        },
        computed: {
            mberInfo: function(){
                return this.$store.getters.getMberInfo;
            },
            dayInfo: function(){
                return this.$store.getters.getDayInfo;
            },
        },
        mounted: function() {
            this.step1.defOrderInfo.reqstSn = this.param.reqstSn;
            this.step1.defSelfOrderInfo.reqstSn = this.param.reqstSn;
            this.step1.defOrderInfo.payDueDt = this.dayInfo.ymd;
            this.step1.defSelfOrderInfo.payDueDt = this.dayInfo.ymd;
            this.openOrderSeInfoPopup();
            this.searchSrvcTmpReqInfo();
        }
    }
</script>